import { IIcon } from './iconConstants'
const OtpIcon = ({ width, height, fill, backgroundColor }: IIcon) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#vxb3drtcca)'>
        <path
          d='M38.997.5a5.2 5.2 0 0 1 5.2 5.2v41.6a5.2 5.2 0 0 1-5.2 5.2h-26a5.2 5.2 0 0 1-5.2-5.2V5.7a5.2 5.2 0 0 1 5.2-5.2h26zm1.56 40.009h-29.12V47.3a1.56 1.56 0 0 0 1.56 1.56h26a1.56 1.56 0 0 0 1.56-1.56v-6.791zM25.997 42.1a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2zm13-37.96h-26a1.56 1.56 0 0 0-1.56 1.56v31.169h29.12V5.7a1.56 1.56 0 0 0-1.56-1.56z'
          fill={backgroundColor}
        />
      </g>
      <path
        d='M49.42 22c0 4.87 0 7.307-1.515 8.82-1.513 1.512-3.948 1.513-8.82 1.513H33.92c-4.87 0-7.307 0-8.82-1.514-1.512-1.514-1.513-3.948-1.513-8.82 0-4.87 0-7.306 1.514-8.819 1.514-1.512 3.948-1.514 8.82-1.514h5.166c4.87 0 7.307 0 8.82 1.514.844.844 1.218 1.974 1.382 3.653'
        fill={fill}
      />
      <path
        d='M49.42 22c0 4.87 0 7.307-1.515 8.82-1.513 1.512-3.948 1.513-8.82 1.513H33.92c-4.87 0-7.307 0-8.82-1.514-1.512-1.514-1.513-3.948-1.513-8.82 0-4.87 0-7.306 1.514-8.819 1.514-1.512 3.948-1.514 8.82-1.514h5.166c4.87 0 7.307 0 8.82 1.514.844.844 1.218 1.974 1.382 3.653'
        stroke='#13974C'
        strokeWidth='2.8'
        strokeLinecap='round'
      />
      <path d='M30 22z' fill={fill} />
      <path
        d='M30 19.5v5m-1.999-3.75L32 23.25m0-2.5-4 2.5'
        stroke='#13974C'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M37 22z' fill={fill} />
      <path
        d='M37 19.5v5m-1.999-3.75L39 23.25m0-2.5-4 2.5'
        stroke='#13974C'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M44 22z' fill={fill} />
      <path
        d='M44 19.5v5m-1.999-3.75L46 23.25m0-2.5-4 2.5'
        stroke='#13974C'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <defs>
        <clipPath id='vxb3drtcca'>
          <path fill={fill} transform='translate(0 .5)' d='M0 0h52v52H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default OtpIcon
